import { render, staticRenderFns } from "./ContratoMainPanel.vue?vue&type=template&id=30d876d4&scoped=true&"
import script from "./ContratoMainPanel.vue?vue&type=script&lang=js&"
export * from "./ContratoMainPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d876d4",
  null
  
)

export default component.exports